const Plane = ({ className = "", color }: { className?: string; color: string }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    role="img"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      data-name="layer1"
      d="M25.729 57.438L41.479 37h15a5 5 0 0 0 0-10h-15L25.727 6.566S24.637 5 23.479 5h-4.213A1.348 1.348 0 0 0 18 5.723c-.252.469.289 1.947.469 2.418S24.637 27 24.637 27H13.479s-4.92-6.578-5.5-7.336A1.639 1.639 0 0 0 6.574 19h-3.1c-.359 0-1.318.064-.812 1.436S7.481 32 7.481 32 3.172 42.193 2.666 43.565 3.119 45 3.479 45h3.1a1.644 1.644 0 0 0 1.406-.664c.578-.758 5.5-7.336 5.5-7.336h11.152s-5.984 18.395-6.166 18.863-.721 1.95-.471 2.418a1.345 1.345 0 0 0 1.266.719h4.213c1.158 0 2.25-1.562 2.25-1.562z"
      fill={color}
    ></path>
    <path
      data-name="opacity"
      d="M61.465 31.879A4.992 4.992 0 0 0 56.479 27h-15L25.727 6.566S24.637 5 23.479 5h-4.213A1.348 1.348 0 0 0 18 5.723c-.252.469.289 1.947.469 2.418S24.637 27 24.637 27H13.479s-4.92-6.578-5.5-7.336A1.639 1.639 0 0 0 6.574 19h-3.1c-.359 0-1.318.064-.812 1.436.475 1.283 4.277 10.289 4.764 11.439z"
      fill="#000064"
      opacity=".15"
    ></path>
  </svg>
);

export default Plane;
